<template>
  <b-list-group v-if="!isLoading" class="my-3">
    <div v-if="taskListArray.length">
      <div v-if="tabIndex === 0">
        <b-list-group-item v-for="(task, index) in taskListArray" :key="index">
          <TaskList
            :task="task"
            :index="index"
            :taskListArray="taskListArray"
            :selectedTaskList="selectedTaskList"
          />
        </b-list-group-item>
      </div>
      <div v-if="tabIndex === 1">
        <div v-for="(task, index) in taskListArray" :key="index">
          <b-list-group-item v-if="!task.value && task.required">
            <TaskList
              :task="task"
              :index="index"
              :taskListArray="taskListArray"
              :selectedTaskList="selectedTaskList"
            />
          </b-list-group-item>
        </div>
      </div>
      <div v-if="tabIndex === 2">
        <div v-for="(task, index) in taskListArray" :key="index">
          <b-list-group-item v-if="task.value">
            <TaskList
              :task="task"
              :index="index"
              :taskListArray="taskListArray"
              :selectedTaskList="selectedTaskList"
            />
          </b-list-group-item>
        </div>
      </div>
      <div v-if="tabIndex === 3">
        <div v-for="(task, index) in taskListArray" :key="index">
          <b-list-group-item v-if="!task.required">
            <TaskList
              :task="task"
              :index="index"
              :taskListArray="taskListArray"
              :selectedTaskList="selectedTaskList"
            />
          </b-list-group-item>
        </div>
      </div>
      <div v-if="showNoTask" class="text-center">No task available</div>
    </div>
  </b-list-group>
  <div
    v-else
    class="text-center d-flex justify-content-center align-items-center mb-3 h-100"
  >
    <b-spinner
      small
      variant="primary"
      type="grow"
      label="Loading..."
    ></b-spinner>
    <b-spinner
      class="mx-4"
      small
      variant="primary"
      type="grow"
      label="Loading..."
    ></b-spinner>
    <b-spinner
      small
      variant="primary"
      type="grow"
      label="Loading..."
    ></b-spinner>
  </div>
</template>
<script>
import TaskList from "@/components/TaskList.vue";
import { mapActions } from "vuex";
export default {
  name: "Tasktab",
  components: {
    TaskList,
  },
  data() {
    return {
      showTaskGroup: [false],
      id: this.$route.params.id,
    };
  },
  props: {
    taskListArray: {
      type: Array,
      default: () => [],
    },
    selectedTaskList: {
      type: String,
      default: "",
    },
    tabIndex: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showNoTask() {
      let filterArr = [];
      if (this.tabIndex === 1) {
        filterArr = this.taskListArray.filter(
          (el) => el.value === false && el.required === true
        );
      } else if (this.tabIndex === 2) {
        filterArr = this.taskListArray.filter((el) => el.value === true);
      } else if (this.tabIndex === 3) {
        filterArr = this.taskListArray.filter((el) => el.required === false);
      } else {
        filterArr = this.taskListArray;
      }
      if (filterArr.length) {
        return false;
      } else return true;
    },
  },
};
</script>
